import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FunctionGroupLogicService } from './logic/function-groups/function-groups-logic.service';
import { FunctionGroupsDaoService } from './dao/function-groups-dao.service';
import { FunctionGroupsStorageDaoService } from './dao/function-groups-dao/function-groups-storage-dao.service';
import { FunctionGroupsService } from './logic/function-groups.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: FunctionGroupsService, useClass: FunctionGroupLogicService },
    {
      provide: FunctionGroupsDaoService,
      useClass: FunctionGroupsStorageDaoService
    }
  ]
})
export class FunctionGroupsModule {}
